import en from "./en"
import es from "./es"
import ca from "./ca"

export default {
	en,
	es,
	ca
}
